// Internal use of token callback to determine optimized behaviors if the token is not yet available

// oxlint-disable-next-line init-declarations -- set externally via setTokenCallback before getToken is called
let tokenCallback: () => Promise<string | null>

export const setTokenCallback = (callback: () => Promise<string | null>) => {
  tokenCallback = callback
}

export const getToken = async () => tokenCallback()
